export default __webpack_public_path__ + "static/media/notification_icon.82aec124.svg";